module.exports = __webpack_public_path__ + "static/media/cupom.d32181e8.png";